import ReactDOM from "react-dom/client";

export const modal = document.getElementById("modal") as HTMLElement;

export const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
